import './QuickIntro.scss';
import { h } from 'vue';
import VimeoEmbed from '../VimeoEmbed';

export default function QuickIntro() {
    return h('div', { class: 'quick-intro' }, [
        h(VimeoEmbed, { src: '872928884' }),
        h(VimeoEmbed, { src: '711995934' }),
        h(VimeoEmbed, { src: '812606236' }),
        h(VimeoEmbed, { src: '810732463' }),
        h(VimeoEmbed, { src: '792521919' }),
        h(VimeoEmbed, { src: '792296991' }),
        h(VimeoEmbed, { src: '882472373' }),
    ]);
}
